import React from 'react'

import cn from 'classnames'
import PropTypes from 'prop-types'

import './index.scss'

class FillViewHeight extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      top: 0,
      isSized: false,
    }
  }
  componentDidMount() {
    const rect = this.self.getBoundingClientRect()
    this.setState({
      top: rect.top,
      isSized: true,
    })
  }
  render() {
    const classNames = cn('fill-view-height-comp', { ready: this.state.isSized })
    return (
      <div
        className={classNames}
        style={{
          height: `calc(100vh - ${this.state.top}px)`,
        }}
        ref={(comp) => (this.self = comp)}
      >
        {this.props.children}
      </div>
    )
  }
}

FillViewHeight.propTypes = {
  children: PropTypes.node.isRequired,
}

export default FillViewHeight
